import { SHELL_ID } from "@aviv-unified-frontend/internal";
import { registerApplication } from "@aviv-unified-frontend/runtime/monitoring";
import { useState } from "react";
import type { ComponentProps, ComponentType } from "react";

import { VERSION } from "../../../constants/environment";

/**
 * HOC around Shell pages to enable early lifecycle hooks registration.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createPageComponent = <Component extends ComponentType<any>>(
  Component: Component,
) => {
  return (props: ComponentProps<Component>) => {
    // Leverage `useState` callback form to run only once the `registerApplication` callback as soon as possible on both runtime (server and client):
    useState(() => {
      registerApplication({
        id: SHELL_ID,
        version: VERSION,
      });
    });

    return <Component {...props} />;
  };
};
